import { isApp, reload } from '@/utils/browser.js'
import { redirectToBridge, redirectToLogin } from '@/utils/url.js'

export function handleUnauthorized (authStore) {
  console.log('[AuthRecovery] unauthorized detected', { recoveryInProgress: authStore.isRecoveryInProgress })
  if (isApp()) {
    // atomic check-and-set on the shared recovery state machine (see
    // useAuthStore) — of however many concurrent 401s land around the same
    // time, only the first gets past this, so at most one bridge redirect is
    // ever triggered per fresh page/session. This also covers "already
    // attempted this session" — whether from this instance or a prior one
    // before a reload.
    const started = authStore.beginBridgeRecovery()
    if (!started) return

    // don't use { once: true } here — the native side can fire other commands
    // on this same channel before unmTokenRefreshed; once:true would consume
    // the listener on that unrelated event and reload() would never run
    const onNativeJSICallback = (event) => {
      if (event.detail && event.detail.command === 'unmTokenRefreshed') {
        console.log('[AuthRecovery] native unmTokenRefreshed received, marking recovery succeeded')
        window.removeEventListener('nativeJSICallback', onNativeJSICallback)
        // markRecoverySucceeded() is a no-op (returns false) if recovery
        // already timed out and gave up — guards against a late/stale native
        // callback resurrecting a recovery we already abandoned
        if (authStore.markRecoverySucceeded()) {
          reload()
        }
      }
    }
    window.addEventListener('nativeJSICallback', onNativeJSICallback)
    redirectToBridge()
    return
  }

  authStore.refreshToken({
    success: () => reload(),
    fail: () => redirectToLogin()
  })
}
